import {Component, Input, OnInit} from '@angular/core';
import {ClrDatagridModule, ClrDatagridSortOrder, ClrIconModule} from "@clr/angular";
import {ActivatedRoute, RouterLink} from "@angular/router";
import {DatePipe, NgIf} from "@angular/common";
import {Delivery, StatusButtons} from "../../../_shared/interfaces";
import {TransportStoreService} from "../../../_shared/services";
import {
  checkCircleIcon,
  ClarityIcons,
  exclamationCircleIcon,
  exclamationTriangleIcon,
  infoCircleIcon,
  timesCircleIcon, twoWayArrowsIcon
} from "@cds/core/icon";

/**
 * Transportscheine als Liste -- eingebettet in `order/details` (je Auftrag)
 * oder als eigene Seite `orders/transport` aus der Seitenleiste (alle
 * Projekte, gefiltert ueber `data.status` der Route).
 */
@Component({
  selector: 'app-order-transport',
  standalone: true,
  imports: [
    ClrDatagridModule,
    ClrIconModule,
    RouterLink,
    DatePipe,
    NgIf
  ],
  templateUrl: './order-transport.component.html',
  styleUrl: './order-transport.component.sass'
})
export class OrderTransportComponent implements OnInit {
  transport: Delivery[] = []
  public loading: boolean = true;
  descSort = ClrDatagridSortOrder.DESC;

  @Input() projectId: string = '';
  @Input() jobId: number = 0;
  @Input() orderId: number = 0;
  /** Ein Status, eine Kommaliste (`running,waiting`) oder `all`. */
  @Input() status: string = 'all';

  // Dasselbe Vokabular wie Formular und Detailseite. Hier standen vorher
  // `onhold` und `done`, die es in der Datenbank nicht gibt -- ein
  // wartender Transport erschien dadurch ohne Statustext.
  statusButtons: StatusButtons[] = [
    { state: 'open',      display: 'Offen',               label: 'alert-info',    icon: 'info-circle'},
    { state: 'running',   display: 'In Arbeit',           label: 'alert-info',    icon: 'info-circle'},
    { state: 'waiting',   display: 'Wartet auf Abholung', label: 'alert-warning', icon: 'exclamation-triangle'},
    { state: 'ontour',    display: 'On Tour',             label: 'alert-danger',  icon: 'exclamation-circle'},
    { state: 'closed',    display: 'Empfang bestätigt',   label: 'alert-success', icon: 'check-circle'},
    { state: 'cancelled', display: 'Storniert',           label: 'alert-danger',  icon: 'times-circle'},
  ];

  private fallbackStatus: StatusButtons = { state: '', display: 'Unbekannt', label: 'alert-info', icon: 'info-circle' };

  constructor(
    private transss: TransportStoreService,
    private route: ActivatedRoute,
  ) {
    ClarityIcons.addIcons(infoCircleIcon, checkCircleIcon, exclamationCircleIcon, exclamationTriangleIcon, timesCircleIcon, twoWayArrowsIcon)
  }

  /** Eigene Seite statt eingebettet: dann gilt die Liste ueber alle Projekte. */
  get standalone(): boolean {
    return !this.projectId;
  }

  ngOnInit(): void {
    const routeStatus = this.route.snapshot.data['status'];
    if (this.standalone && routeStatus) {
      this.status = routeStatus;
    }
    this.loadList();
  }

  statusOf(status: string): StatusButtons {
    return this.statusButtons.find(el => el.state === status) ?? this.fallbackStatus;
  }

  findButtonClass(status: string) {
    return "alert " + this.statusOf(status).label + " alert-sm";
  }

  loadList() {
    // Das RMS verlangt eine Projektnummer; `0` steht fuer alle Projekte.
    this.transss.getTransport(this.projectId || '0', this.orderId, 0, this.status).subscribe({
      next: data => {
        this.transport = data?.object ?? [];
      },
      complete: () => {
        this.loading = false;
        this.descSort = ClrDatagridSortOrder.DESC;
      },
      error: () => {
        this.loading = false;
      }
    });
  }
}
